import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";

var _dec, _class;

import React, { Component } from 'react';
import { autobind } from 'core-decorators';
import { StyleSheet, styled } from '@rexlabs/styling';
var defaultStyles = StyleSheet({
  container: {
    display: 'flex',
    flex: '1 1 auto',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    boxSizing: 'border-box',
    height: '6rem',
    borderBottom: '1px solid transparent',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: 'grey',
    transition: 'color 150ms ease-out',
    cursor: 'pointer',
    '&:hover': {
      color: 'black'
    }
  },
  containerActive: {
    color: 'black'
  },
  containerDisabled: {
    color: 'lightgrey',
    cursor: 'default',
    '&:hover': {
      color: 'lightgrey'
    }
  }
});
var Tab = (_dec = styled(defaultStyles), _dec(_class = autobind(_class =
/*#__PURE__*/
function (_Component) {
  _inherits(Tab, _Component);

  function Tab() {
    _classCallCheck(this, Tab);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tab).apply(this, arguments));
  }

  _createClass(Tab, [{
    key: "setHandledRef",
    value: function setHandledRef(r) {
      var _this$props = this.props,
          setRef = _this$props.setRef,
          name = _this$props.name,
          label = _this$props.label;

      if (setRef) {
        setRef(r, {
          name: name,
          label: label
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          name = _this$props2.name,
          label = _this$props2.label,
          isDisabled = _this$props2.isDisabled;

      if (!isDisabled && onClick) {
        onClick(event, {
          name: name,
          label: label
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          s = _this$props3.styles,
          name = _this$props3.name,
          label = _this$props3.label,
          isActive = _this$props3.isActive,
          isDisabled = _this$props3.isDisabled;
      return React.createElement("li", _extends({
        key: name,
        role: "tab",
        "aria-selected": isActive.toString(),
        ref: this.setHandledRef,
        onClick: this.handleClick
      }, s('container', {
        containerActive: isActive,
        containerDisabled: isDisabled
      })), label);
    }
  }]);

  return Tab;
}(Component)) || _class) || _class);
export default Tab;